export default results => {
  const preparedResults = results.map(r => ({
    answerString: r.answer_string,
    resultId: r.resultId
  }));

  return preparedResults;
};
